import {
	filterByCreditQuality,
	filterByLoanAmountServiced,
	filterByMortgageType,
} from "../../src/helpers/filters";

export const MORTGAGES_PATH = "mortgages";
export const LEASE_BUYOUT_PATH = "lease-buyout";
export const BUSINESS_LENDING_PATH = "business-lending";
export const ANNUITIES_PATH = "annuities";

const ETHOS_ANNUITIES_SLUG = "ethos-annuities";

/* URL filter parameters */
export const PURCHASE_MORTGAGE_TYPE_URL_PARAMETER = "mortgage-purchase";
export const REFINANCE_MORTGAGE_TYPE_URL_PARAMETER = "mortgage-refinance";

/* Constants used for filtering UI*/
export const PURCHASE_MORTGAGE_TYPE_FILTERING_VALUE = "purchase";
export const PURCHASE_MORTGAGE_TYPE_FILTERING_LABEL = "Purchase";
export const REFINANCE_MORTGAGE_TYPE_FILTERING_VALUE = "refinance";
export const REFINANCE_MORTGAGE_TYPE_FILTERING_LABEL = "Refinance";

export const EXCELLENT_CREDIT_QUALITY_FILTERING_VALUE = "Excellent";
export const EXCELLENT_CREDIT_QUALITY_FILTERING_LABEL = "Excellent (720-850)";
export const GOOD_CREDIT_QUALITY_FILTERING_VALUE = "Good";
export const GOOD_CREDIT_QUALITY_FILTERING_LABEL = "Good (680-719)";
export const FAIR_CREDIT_QUALITY_FILTERING_VALUE = "Fair";
export const FAIR_CREDIT_QUALITY_FILTERING_LABEL = "Fair (620-679)";
export const POOR_CREDIT_QUALITY_FILTERING_VALUE = "Poor";
export const POOR_CREDIT_QUALITY_FILTERING_LABEL = "Poor (300-619)";

export const UNDER_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_VALUE =
	"under_100k";
export const UNDER_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_LABEL =
	"Under $100k";
export const HUNDRED_TO_TWO_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_VALUE =
	"100k_200k";
export const HUNDRED_TO_TWO_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_LABEL =
	"$100k to $200k";
export const TWO_HUNDRED_TO_SIXTY_FOUR_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_VALUE =
	"200k_640k";
export const TWO_HUNDRED_TO_SIXTY_FOUR_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_LABEL =
	"$100k to $200k";
export const OVER_SIXTY_FOUR_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_VALUE =
	"over_640k";
export const OVER_SIXTY_FOUR_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_LABEL =
	"Over $640k";

/* Also constants for filtering UI, specifically filtering keys*/
export const MORTGAGE_TYPE_FILTERING_KEY = "mortgageType";
export const CREDIT_QUALITY_FILTERING_KEY = "creditQuality";
export const LOAN_AMOUNT_SERVICED_FILTERING_KEY = "loanAmountServiced";

const MORTGAGE_TYPE_OPTIONS = [
	{
		value: PURCHASE_MORTGAGE_TYPE_FILTERING_VALUE,
		label: PURCHASE_MORTGAGE_TYPE_FILTERING_LABEL,
	},
	{
		value: REFINANCE_MORTGAGE_TYPE_FILTERING_VALUE,
		label: REFINANCE_MORTGAGE_TYPE_FILTERING_LABEL,
	},
	{
		value: "default",
		label: "All",
	},
];

const CREDIT_QUALITY_OPTIONS = [
	{
		value: EXCELLENT_CREDIT_QUALITY_FILTERING_VALUE,
		label: EXCELLENT_CREDIT_QUALITY_FILTERING_LABEL,
	},
	{
		value: GOOD_CREDIT_QUALITY_FILTERING_VALUE,
		label: GOOD_CREDIT_QUALITY_FILTERING_LABEL,
	},
	{
		value: FAIR_CREDIT_QUALITY_FILTERING_VALUE,
		label: FAIR_CREDIT_QUALITY_FILTERING_LABEL,
	},
	{
		value: POOR_CREDIT_QUALITY_FILTERING_VALUE,
		label: POOR_CREDIT_QUALITY_FILTERING_LABEL,
	},
	{
		value: "default",
		label: "All",
	},
];

const LOAN_AMOUNT_SERVICED_OPTIONS = [
	{
		value: UNDER_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_VALUE,
		label: UNDER_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_LABEL,
	},
	{
		value: HUNDRED_TO_TWO_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_VALUE,
		label: HUNDRED_TO_TWO_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_LABEL,
	},
	{
		value:
			TWO_HUNDRED_TO_SIXTY_FOUR_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_VALUE,
		label:
			TWO_HUNDRED_TO_SIXTY_FOUR_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_LABEL,
	},
	{
		value: OVER_SIXTY_FOUR_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_VALUE,
		label: OVER_SIXTY_FOUR_HUNDRED_K_LOAN_AMOUNT_SERVICED_FILTERING_LABEL,
	},
	{
		value: "default",
		label: "All",
	},
];

export const RC_SITE_CONFIGURATION = {
	[MORTGAGES_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
		filteringInformation: {
			filterFunctions: {
				[MORTGAGE_TYPE_FILTERING_KEY]: filterByMortgageType,
				[CREDIT_QUALITY_FILTERING_KEY]: filterByCreditQuality,
				[LOAN_AMOUNT_SERVICED_FILTERING_KEY]: filterByLoanAmountServiced,
			},
			urlPathFilteringConfiguration: {
				[PURCHASE_MORTGAGE_TYPE_URL_PARAMETER]: [
					{
						filteringKey: MORTGAGE_TYPE_FILTERING_KEY,
						filterValue: PURCHASE_MORTGAGE_TYPE_FILTERING_VALUE,
					},
				],
				[REFINANCE_MORTGAGE_TYPE_URL_PARAMETER]: [
					{
						filteringKey: MORTGAGE_TYPE_FILTERING_KEY,
						filterValue: REFINANCE_MORTGAGE_TYPE_FILTERING_VALUE,
					},
				],
			},
			filteringControls: [
				{
					title: "Mortgage Type",
					filteringKey: MORTGAGE_TYPE_FILTERING_KEY,
					icon: "/react-images/ratecompare/mortgageType.svg",
					options: MORTGAGE_TYPE_OPTIONS,
				},
				{
					title: "Credit Score",
					filteringKey: CREDIT_QUALITY_FILTERING_KEY,
					icon: "/react-images/ratecompare/creditQuality.svg",
					options: CREDIT_QUALITY_OPTIONS,
				},
				{
					title: "Loan Amount",
					filteringKey: LOAN_AMOUNT_SERVICED_FILTERING_KEY,
					icon: "/react-images/ratecompare/loanAmountServiced.svg",
					options: LOAN_AMOUNT_SERVICED_OPTIONS,
				},
			],
			modalFilteringControls: [
				{
					title: "What type of mortgage do you need?",
					filteringKey: MORTGAGE_TYPE_FILTERING_KEY,
					icon: "/react-images/ratecompare/mortgageType.svg",
					options: MORTGAGE_TYPE_OPTIONS,
				},
				{
					title: "What is your credit score?",
					filteringKey: CREDIT_QUALITY_FILTERING_KEY,
					icon: "/react-images/ratecompare/creditQuality.svg",
					options: CREDIT_QUALITY_OPTIONS,
				},
				{
					title: "What loan amount are you looking for?",
					filteringKey: LOAN_AMOUNT_SERVICED_FILTERING_KEY,
					icon: "/react-images/ratecompare/loanAmountServiced.svg",
					options: LOAN_AMOUNT_SERVICED_OPTIONS,
				},
			],
		},
	},
	[LEASE_BUYOUT_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[BUSINESS_LENDING_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
	},
	[ANNUITIES_PATH]: {
		preventRenderingCompanyListHeader: true,
		showFeaturedCompany: true,
		deemphasizedCompanyVisitSlugOverrides: {
			"fastbreak-gainsbridge": { defaultVisitSlug: ETHOS_ANNUITIES_SLUG },
			"parityflex-gainsbridge": { defaultVisitSlug: ETHOS_ANNUITIES_SLUG },
			"steadypace-gainsbridge": { defaultVisitSlug: ETHOS_ANNUITIES_SLUG },
		},
	},
};
